const state = {
    surveys: [],
    currentSurvey: null,
    questionTypes: [],
    surveyConfig: null,
    responses: [],
    summary: null,
    overview: null,
    botConfig: null,
    loading: false
};

export default state;
